<template>
  <div style="display: inline-block; vertical-align: inherit;padding-left: 25px;">
    <div class="group-badge" v-for="department in departments">
      <UserDepartmentBadgeComponent
          :key="department.id"
          :user-department="department"
          :border="collapse"
          size="small"
      ></UserDepartmentBadgeComponent>
    </div>
    <div class="group-badge" v-for="user in users">
      <UserBadgeComponent
          :key="user.id"
          :user="user"
          :display-name="!collapse"
          :border="collapse"
          size="small"
      ></UserBadgeComponent>
    </div>
  </div>
</template>

<script>
import UserDepartmentBadgeComponent from "../../user_department/components/BadgeComponent";
import UserBadgeComponent from "../../user/components/BadgeComponent";

export default {
  name: "TaskBadgeGroupComponent",
  components: {UserBadgeComponent, UserDepartmentBadgeComponent},
  props: {
    departments: {
      type: Array,
      required: true,
      default: []
    },
    users: {
      type: Array,
      required: true,
      default: []
    }
  },
  computed: {
    collapse: function () {
      return (this.departments.length + this.users.length) > 1
    }
  }
}
</script>

<style>
.group-badge {
  display: inline-block;
  vertical-align: inherit;
  margin-left: -25px;
}
</style>
